import React, { useEffect } from 'react';
interface TurnAdvanceProps {
  onComplete: () => void;
  turn: number;
}
export function TurnAdvance({
  onComplete,
  turn
}: TurnAdvanceProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background/90 backdrop-blur-md" data-id="element-351">
      <div className="text-center space-y-4" data-id="element-352">
        <div className="relative" data-id="element-353">
          {/* Outer orbit ring */}
          <div className="w-24 h-24 border-2 border-primary/30 rounded-full absolute inset-0 animate-orbit-spin" style={{
          animationDuration: '3s'
        }} data-id="element-354" />
          {/* Inner spinning circle */}
          <div className="w-16 h-16 border-4 border-surface-highlight border-t-primary rounded-full animate-spin mx-auto absolute inset-0 m-auto shadow-glow-teal" data-id="element-355" />
          {/* Center text */}
          <div className="absolute inset-0 flex items-center justify-center font-mono font-bold text-text-primary text-lg" data-id="element-356">
            Q{turn}
          </div>
        </div>
        <h2 className="text-2xl font-bold text-text-primary animate-pulse mt-28" data-id="element-357">
          Processing Quarter...
        </h2>
        <div className="flex flex-col space-y-1 text-sm text-text-secondary font-mono" data-id="element-358">
          <span data-id="element-359">Calculating Revenue...</span>
          <span data-id="element-360">Paying Salaries...</span>
          <span data-id="element-361">Updating Market Demand...</span>
        </div>
      </div>
    </div>;
}